import React from 'react';

import Tooltip from 'components/tooltip';
import HelpTooltip from 'components/help-tooltip';
import AvatarBase from 'components/avatar-base';

import './GanttSideEntry.styles.css';

import IconPlus from 'icons/icon-plus'

export const GanttSideEntryMetaItem = ({ icon, title, additional, iconAfter, helpText, onClick }) => {
    return (
        <div className="meta-item">
            {
                icon ? (
                    <div className="meta-item-icon">
                        { icon }
                    </div>
                ) : null
            }

            <div className={'meta-item-text' + (onClick ? ' action over-click-overlay underlined-text-on-hover' : '')} onClick={onClick}>
                { title }

                { iconAfter }

                {
                    helpText ? <HelpTooltip>{ helpText }</HelpTooltip> : null
                }
            </div>

            {
                additional ? (
                    <div className="meta-item-additional">
                        { additional }
                    </div>
                ) : null
            }
        </div>
    );
}

export const GanttSideEntryTitleIcon = ({ tooltip, children }) => {
    return (
        <span className={'title-icon-holder' + (tooltip ? ' over-click-overlay' : '')}>
            <Tooltip tooltip={ tooltip } disabled={!tooltip}>
                <span className="title-icon">
                    { children }
                </span>
            </Tooltip>
        </span>
    );
}

const GanttSideEntry = ({ layout, title, avatarProps, progress, expanded, type, placeholder, titleIcons, selected, plusTooltip, alignTop, style, mainHeight, onClick, onPlusClick, footer, children }) => {
    return (
        <div className={'gantt-side-entry' + (type ? ` ${type}` : '') + (layout ? ` layout-${layout}` : '') + (placeholder ? ' placeholder' : '') + (alignTop ? ' align-top' : '') + (selected ? ' selected' : '') + (expanded ? ' expanded' : '')} style={style}>

            <div className="entry-inner">
                <div className="entry-main" style={{ height: mainHeight }}>
                    {
                        onClick ? <div className="entry-click-overlay" onClick={onClick} /> : null
                    }

                    <div className="entry-body">
                        {
                            avatarProps ? <AvatarBase size="xsmall" {...avatarProps} /> : null
                        }
                        
                        <div className="entry-title">
                            { title }

                            { titleIcons }
                        </div>

                        {
                            progress || type ? (
                                <span className={'entry-progress tag-pill ' + type}>{progress}%</span>
                            ) : null
                        }

                        {
                            onPlusClick ? (
                                <Tooltip tooltip={ plusTooltip } disabled={!plusTooltip} withTooltipHover={false}>
                                    <button className="entry-btn-plus over-click-overlay btn btn-icon btn-secondary btn-square btn-xsmall" onClick={onPlusClick}>
                                        <IconPlus size="11px" />
                                    </button>
                                </Tooltip>
                            ) : null
                        }
                    </div>

                    <div className="entry-meta">
                        { children }
                    </div>
                </div>

                { footer }
            </div>
        </div>
    );
};

export default GanttSideEntry;
